import RemoveNotifyList from './RemoveNotifyList';

export default RemoveNotifyList;
